export enum StorageFailure {
  Unavailable = 'storage-unavailable',
  ReadFailed = 'storage-read-failed',
  WriteFailed = 'storage-write-failed',
  Invalid = 'storage-invalid'
}
